export default __webpack_public_path__ + "main.min.css";